import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input
} from '@angular/core';
import { MomentModule } from 'ngx-moment';
import { Item } from 'src/app/models';
import { KeyValuePairComponent } from 'src/app/shared/general/key-value-pair/key-value-pair.component';
import { ConfigService } from 'src/app/shared/services/config.service';

@Component({
  selector: 'app-item-extras',
  standalone: true,
  imports: [KeyValuePairComponent, MomentModule],
  template: `
    <div class="flex flex-col justify-start items-stretch w-full gap-y-2">
      @for (extra of extras(); track extra.label) {
        @if (extra.date) {
          <app-key-value-pair
            [name]="extra.label"
            [value]="extra.value | amDateFormat: dateFormat"
          ></app-key-value-pair>
        } @else {
          <app-key-value-pair
            [name]="extra.label"
            [value]="extra.value"
            notSetMessage="Not specified"
          ></app-key-value-pair>
        }
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItemExtrasComponent {
  item = input.required<Item>();

  knownExtrasLabels = {
    disposal_date: 'Disposal Date',
    disposal_method: 'Disposal Method',
    disposal_details: 'Disposal Details'
  };

  dateFormat = ConfigService.dates.dateFormat;

  extras = computed<{ label: string; value: string; date: boolean }[]>(() => {
    if (!this.item().extras) return [];
    return Object.entries(this.item().extras)
      .filter(([key]) => Object.keys(this.knownExtrasLabels).includes(key))
      .map(([key, value]) => {
        return {
          label: this.knownExtrasLabels[key],
          value: value as string,
          date: key === 'disposal_date'
        };
      });
  });
}
